import { AESDecrypt, AesCBCDecryptV3 } from '../crypto'

export const EVT_PAGE_VISITED = 10001
export const EVT_PAGE_LOADING = 10002
export const EVT_PAGE_STAYING = 10003
export const EVT_ITEM_EXPOSED = 10004
export const EVT_CLICK = 10100

/**
 * @param {string} name
 */
function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

export function track(params) {
  console.log('track')
}

export function uploadHelpEvent(key, helpful, level) {
  console.log('uploadHelpEvent')
}

export function setNavbar(config) {
  return Promise.resolve()
}

export function backToNative() {
  console.log('backToNative')
  return Promise.resolve()
}

export function openEmail() {
  console.log('open email')
}

export function getAppName() {
  return Promise.resolve('eufy security')
}

export function getNativeInfo() {
  return Promise.resolve({
    token: getCookie('token'),
    email: getCookie('email') || 'parker.zhang@anker.com',
    gtoken: getCookie('gtoken'),
    appName: getCookie('app_name'),
    appVersion: getCookie('appVersion') || 'V4.8.0_178',
    domain: getCookie('domain') || 'security-app-qa.eufylife.com',
    country: getCookie('country'),
  })
}

export function uploadTrackings(params) {
  console.log('uploadTrackings', params)
}

export function openWebview(url) {
  console.log(`openWebview with url: ${url}`)
  window.open(url)
}

export function openBrowser(url) {
  console.log(`openBrowser with url: ${url}`)
}

export function startPay(data) {
  console.log(`startPay with data: `, data)
  return Promise.resolve(true)
}

export function encrypt(data) {
  return Promise.resolve(data)
}

export async function decrypt(data) {
  console.log('decrypt: %s', data)
  let res
  try {
    res = JSON.parse(await AESDecrypt(data.data))
  } catch (e) {
    console.error(e)
  }
  return res
}

export function togglePullToRefresh(isRefreshable) {
  console.log(`togglePullToRefresh: ${isRefreshable}`)
}

export async function getHeaderV3(data) {
  log('getHeaderV3: %s', data)
}

export async function encryptV3(data) {
  console.log('encryptV3: %s', data)
  log('encryptV3: %s', data)
}
export async function decryptV3App(data) {
  log('decryptV3App: %s', data)
}
export async function decryptV3H5(data, shareKey) {
  if (!data) {
    return data
  }
  const decryptjson = await AesCBCDecryptV3(data, shareKey)
  try {
    return JSON.parse(decryptjson)
  } catch (error) {
    return decryptjson
  }
}
